import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';

const FanPulley = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Fan Pulley</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.fanPulleyQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '9%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.fanPulleyType'
                type='text'
                control={control}
                label='Type'
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.fanPulleyBush'
                type='text'
                control={control}
                label='Bush'
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.fanPulleyBore'
                type='text'
                control={control}
                label='Bore'
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default FanPulley;
